import {UserIconList} from '@/pages/_shared/user-icon-list';
import {Button} from '@/shadcn_components/ui/button';
import {Edit, GroupIcon, Trash2, UsersIcon, X} from 'lucide-react';

interface CommentSectionHeaderProps {
  conversation: any;
}

export const CommentSectionHeader = ({conversation}: CommentSectionHeaderProps) => {
  //   const onEditMembers = () => {
  //     console.log('Edit conversation:', conversation);
  //   };
  return (
    // <div className="sticky top-0 z-10 bg-white shadow-md h-12 items-center flex justify-between p-2">
    <div className="flex flex-col gap-1 p-1">
      <h3 className="text-md font-medium">{conversation.name || 'Trao đổi'}</h3>
      <p>{conversation.description}</p>
      {/* <div className="flex gap-2">
        <Button variant="ghost" size="sm" onClick={onEditMembers}>
          <UsersIcon className="h-4 w-4" />
        </Button>
      </div> */}
      {conversation.members?.length > 0 && <UserIconList users={conversation.members} linkPrefix={false}/>}
    </div>
  );
};
